/**
 * Zone 3b: Social trends area chart — H2A/H2H/Group message trends (30d).
 * No dimension tabs: backend only has data by conversation type.
 */

import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { t } from "../i18n";

type SocialTrendPoint = {
  readonly date: string;
  readonly h2a: number;
  readonly h2h: number;
  readonly group: number;
};

type Props = {
  readonly data: ReadonlyArray<SocialTrendPoint>;
  readonly height?: number;
};

const TOOLTIP_STYLE: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid var(--color-border)",
  borderRadius: 6,
  padding: "8px 12px",
  fontSize: 13,
};

export function SocialTrendsChart({
  data,
  height = 280,
}: Props): React.JSX.Element {
  return (
    <div>
      <h3 style={s.title}>{t("dashboard.social_trends_title")}</h3>
      <ResponsiveContainer width="100%" height={height}>
        <AreaChart data={data as unknown as Record<string, unknown>[]}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" tick={{ fontSize: 12 }} />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip contentStyle={TOOLTIP_STYLE} />
          <Legend verticalAlign="bottom" />
          <Area
            type="monotone"
            dataKey="h2a"
            name={t("dashboard.h2a_label")}
            stroke="#2563eb"
            fill="#2563eb"
            fillOpacity={0.15}
            strokeWidth={2}
          />
          <Area
            type="monotone"
            dataKey="h2h"
            name={t("dashboard.h2h_label")}
            stroke="#111111"
            fill="#111111"
            fillOpacity={0.1}
            strokeWidth={2}
          />
          <Area
            type="monotone"
            dataKey="group"
            name={t("dashboard.group_label")}
            stroke="#8b5cf6"
            fill="#8b5cf6"
            fillOpacity={0.1}
            strokeWidth={2}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  title: {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 12,
    padding: "0 4px",
  },
};
